import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  chartList: {
    '.ant-list-items': {
      maxHeight: 254,
      overflow: 'auto'
    }
  },
  chartTitle: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  },

  editCell: {
    display: 'flex',
    justifyContent: 'space-between',
    minWidth: 'max-content'
  },

  sideMenu: {
    borderRadius: 8,
    border: '1px solid rgba(5, 5, 5, 0.06)'
  },
  listBullet: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    display: 'inline-block'
  }
}))
